import React from 'react'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import { get } from 'lodash'
import { FlexContainer } from 'base-components'
import { FormikSelect, FormikInput, Button } from '../../common'

const CancelOrder = ({ loading, onSubmit, resetDrawer }) => (
  <Formik
    validationSchema={
      Yup.object().shape({
        contactType: Yup.string().required('form.validations.required'),
        comment: Yup.string().required('form.validations.required')
      })
    }
    onSubmit={(values, { setSubmitting }) => {
      const contactType = get(values, 'contactType.label', '')
      const comment = get(values, 'comment', '')
      onSubmit(comment, contactType)
    }}
    onReset={resetDrawer}
    initialValues={{
      contactType: '',
      comment: ''
    }}
    render={({ handleSubmit, handleReset, isValid, isSubmitting }) => (
      <Form onSubmit={handleSubmit} onReset={handleReset}>
        <Field
          component={FormikSelect}
          label='Motivo'
          name='contactType'
          options={[
            { label: 'Cliente Solicita Anular', value: 'requested-by-client' },
            { label: 'Anulación por Fraude', value: 'fraud' },
            { label: 'Anulación por Quiebre', value: 'out' }
          ]}
        />
        <Field
          component={FormikInput}
          name='comment'
          label='Motivo o descripción'
          textArea
          maxLength='500'
        />
        <FlexContainer justify='flex-end' style={{ width: '100%' }}>
          <Button link text='btn.action.cancel' disabled={loading || isSubmitting} htmlType='reset' width={100} />
          <Button disabled={loading || isSubmitting || !isValid} loading={loading || isSubmitting} htmlType='submit' text='btn.action.confirm' width={100} />
        </FlexContainer>
      </Form>
    )
    }
  />
)

export default CancelOrder
